import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postAgent18, postAgent19, postAgent20 } from "./VipListCRUD";
import { vipListSlice } from "./VipListSlice";

const { actions } = vipListSlice;

export const fetchVipList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));
  dispatch(actions.vipListFetched({ data: null }));

  return postAgent18(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const fetchVipReport = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));
  dispatch(actions.vipReportFetched({ data: null }));

  return postAgent19(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipReportFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const fetchVipDownline = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));
  dispatch(actions.vipDownlineFetched({ data: null }));

  return postAgent20(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipDownlineFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipDownline");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const manageVipBalance = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent19(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipBalanceManaged({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: manageVipBalance");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
